import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RoutingStateService {
  private previousUrl = '/index';
  private currentUrl: string;

  constructor(private router: Router) { }

  public loadRouting(): void {
    this.currentUrl = this.router.url;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(
        (e: NavigationEnd) => {
          this.previousUrl = this.currentUrl;
          this.currentUrl = e.url;
        },
        (error) => {
          throw new Error(error);
        }
      );
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

}
